import Image from 'next/image';
import { getContentfulImage } from 'UI/components/Illustration/utils/helpers';
import cn from 'classnames';
import LinkWrapper from 'components/Common/LinkWrapper';
import { routes } from 'utils/routes';
import styles from './styles.module.scss';
import { NavItem } from '../NavItem';
import { FEATURED_CASES_PREVIEWS, PROJECTS } from '../../utils/headerConstants';

const WorksMenu = ({ isLightTheme, isPageScrolledDown }) => (
  <div className={cn(styles.dropdownContainer, { [styles.light]: isLightTheme || isPageScrolledDown })}>
    <div className={styles.contentContainer}>
      <div className={styles.leftContent}>
        <p>Featured Cases</p>
        <div className={styles.teamList}>
          {FEATURED_CASES_PREVIEWS.map(({ name, image, path }) => (
            <LinkWrapper
              isLocalLink
              path={path}
              className={styles.projectLink}
            >
              <div className={styles.memberContainer}>
                <div className={styles.imageContainer}>
                  <Image
                    src={getContentfulImage({ src: image, format: 'webp', width: 600 })}
                    width={272}
                    height={140}
                    lazyBoundary="700px"
                    unoptimized
                    loader={(args) => getContentfulImage({ ...args, format: 'webp', width: 300 })}
                    className={styles.memberImage}
                  />
                </div>
                <p>{name}</p>
              </div>
            </LinkWrapper>
          ))}
        </div>
        <LinkWrapper
          isLocalLink
          path={routes.portfolio.path}
          className={styles.seeAllButton}
        >
          <span>See All Cases</span>
        </LinkWrapper>
      </div>
    </div>
    <div className={styles.ourWorkContent}>
      <div>
        <p>Other projects</p>
        <div>
          {PROJECTS.map(({ title, description, path }) => (
            <NavItem
              title={title}
              description={description}
              path={path}
            />
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default WorksMenu;
